import React from 'react'
import styled from 'styled-components'
import {
  PaperBlock,
  PaperQuestion,
  QuestionTypeEnum,
} from 'packages/sdks-next/growp'
import { CollapsibleDiv } from '@seiue/ui'
import { GrowpIcon } from 'packages/components/GrowpIcon'
import { RichTextRenderer } from 'packages/components/RichText'
import { getSubQuestionsByParentId } from './utils'
import { useAnswersManagement } from './context'

/**
 * 答案与解析展示
 * @param param - 参数
 * @param param.mainQuestion - 当前题目
 * @param param.block - 所有子题
 * @returns React.ReactNode
 */
export const Analysis: React.FC<{
  mainQuestion: PaperQuestion
  block: PaperBlock
  LeftNode?: React.ReactNode
}> = ({ mainQuestion, block, LeftNode }) => {
  const { analysis, type } = mainQuestion
  const { showAnswer } = useAnswersManagement()
  const getAnswers = () => {
    if (type === QuestionTypeEnum.FillInBlank) {
      const subQuestions = getSubQuestionsByParentId(
        block.questions || [],
        mainQuestion.id
      )
      const allAnswerList = subQuestions.map((question, index) => {
        return `
          <div>
            <span
              style="
                display: inline-block;
                width: 18px;
                height: 18px;
                border-radius: 50%;
                border: 1px solid #718999;
                border-color: #718999;
                color: #718999;
                font-size: 12px;
                line-height: 18px;
                text-align: center;
                flex-shrink: 0;
                transform: scale(0.8);
                font-weight: 500;
              "
            >
              ${index + 1}
            </span>
            ${
              question.standardAnswers?.join('或').replace(/p>/g, 'span>') ||
              '-'
            }
          </div>
        `
      })
      return allAnswerList.join('')
    }
    return mainQuestion.standardAnswers?.join('、') || '-'
  }
  return (
    <Wrapper>
      <CollapsibleDiv
        contentStyle={{
          padding: '0 0',
        }}
        target={32}
        disabled={!showAnswer}
        defaultCollapsed={true}
        triggerButton={(collapsed: boolean) => {
          return (
            <TriggerBtnWrapper>
              {showAnswer ? (
                <>
                  <CollapsedTitle>
                    {collapsed ? '展开解析' : '收起解析'}
                  </CollapsedTitle>
                  <GrowpIcon
                    name={collapsed ? 'Bottom' : 'Top'}
                    size={14}
                    color="#718999"
                  />
                </>
              ) : null}
            </TriggerBtnWrapper>
          )
        }}
      >
        {LeftNode || (
          <div
            style={{
              minHeight: '32px',
            }}
          />
        )}

        <AnalysisWrapper>
          <AnalysisItem>
            <Tag>答案</Tag>
            <RichTextRenderer value={getAnswers() || '-'} />
          </AnalysisItem>
          <AnalysisItem>
            <Tag>解析</Tag>
            <RichTextRenderer value={analysis || '-'} />
          </AnalysisItem>
        </AnalysisWrapper>
      </CollapsibleDiv>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  /* margin-top: 8px; */
`

const TriggerBtnWrapper = styled.div`
  width: 74px;
  height: 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  padding: 1px 4px;
  color: ${(props) => props.theme.text._2};
`

const CollapsedTitle = styled.div`
  color: ${(props) => props.theme.text._2};
  font-weight: 400;
`

const AnalysisWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 9px;
  padding: 12px 12px;
  border-radius: 8px;
  background-color: ${(props) => props.theme.background._4};
  flex-shrink: 0;
`

const AnalysisItem = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 9px;
`

const Tag = styled.div`
  width: 40px;
  height: 22px;
  border-radius: 4px;
  padding: 1px 8px;
  font-size: 12px;
  line-height: 20px;
  color: ${(props) => props.theme.text._1};
  background-color: ${(props) => props.theme.background._2};
  flex-shrink: 0;
`
